import { useCallback, useEffect, useState } from 'react';

const useHash = () => {
  const [hash, setHash] = useState(() =>
    typeof window !== 'undefined' ? window?.location?.hash : null,
  );

  const hashChangeHandler = useCallback(() => {
    setHash(window?.location?.hash);
  }, []);

  useEffect(() => {
    window.addEventListener('hashchange', hashChangeHandler);
    document.addEventListener('hashchange', hashChangeHandler);
    
    return () => {
      document.removeEventListener('hashchange', hashChangeHandler);
      window.removeEventListener('hashchange', hashChangeHandler);
    };
  }, []);

  const updateHash = useCallback(
    (newHash) => {
      if (typeof window !== 'undefined' && newHash !== hash) {
        if (newHash === '') {
          window.history.pushState(
            '',
            document.title,
            window.location.pathname + window.location.search,
          );
        } else {
          window.location.hash = newHash;
        }

        setHash(newHash);
      }
    },
    [hash],
  );

  return [hash, updateHash];
};

export default useHash;
